<template>
  <div class="room-detail-container">
    <h2>房间详情</h2>
    <el-card shadow="hover">
      <el-descriptions title="基本信息" :column="2">
        <el-descriptions-item label="ID">{{ roomDetail.id }}</el-descriptions-item>
        <el-descriptions-item label="房间号">{{ roomDetail.room_number }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ getTypeName(roomDetail.type) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ getStatusName(roomDetail.status) }}</el-descriptions-item>
        <el-descriptions-item label="价格">¥{{ roomDetail.price }}</el-descriptions-item>
        <el-descriptions-item label="容纳人数">{{ roomDetail.capacity }}人</el-descriptions-item>
        <el-descriptions-item label="楼层">{{ roomDetail.floor }}楼</el-descriptions-item>
        <el-descriptions-item label="床型">{{ getBedTypeName(roomDetail.bed_type) }}</el-descriptions-item>
        <el-descriptions-item label="面积">{{ roomDetail.area }}平方米</el-descriptions-item>
        <el-descriptions-item label="窗户">{{ roomDetail.window }}</el-descriptions-item>
        <el-descriptions-item label="无烟房">{{ roomDetail.smoke_free ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="描述" :span="2">{{ roomDetail.description || '-' }}</el-descriptions-item>
      </el-descriptions>
      
      <div class="detail-actions">
        <el-button @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleEdit">编辑</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'RoomDetail',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const roomId = route.params.id;
    
    const roomDetail = ref({
      id: '',
      room_number: '',
      type: '',
      status: '',
      price: 0,
      capacity: 0,
      floor: 0,
      bed_type: '',
      area: 0,
      window: '',
      smoke_free: false,
      description: ''
    });
    
    // 获取房间详情
    const fetchRoomDetail = async () => {
      try {
        const response = await request({
          url: `/manage/rooms/${roomId}`,
          method: 'get'
        });
        roomDetail.value = response.data;
      } catch (error) {
        ElMessage.error('获取房间详情失败');
        console.error(error);
        router.push('/rooms/list');
      }
    };
    
    // 页面加载时获取房间详情
    onMounted(() => {
      fetchRoomDetail();
    });
    
    // 获取类型名称
    const getTypeName = (type) => {
      const typeMap = {
        'standard': '标准间',
        'single': '单人间',
        'deluxe': '豪华间',
        'presidential': '总统套房',
        'family': '家庭房'
      };
      return typeMap[type] || type;
    };
    
    // 获取状态名称
    const getStatusName = (status) => {
      const statusMap = {
        'available': '可用',
        'occupied': '已占用',
        'cleaning': '清洁中',
        'maintenance': '维护中'
      };
      return statusMap[status] || status;
    };
    
    // 获取床型名称
    const getBedTypeName = (bedType) => {
      const bedTypeMap = {
        'single': '单床',
        'double': '双床',
        'king': '大床',
        'multiple': '多床'
      };
      return bedTypeMap[bedType] || bedType;
    };
    
    // 返回列表页面
    const handleBack = () => {
      router.push('/rooms/list');
    };
    
    // 跳转到编辑页面
    const handleEdit = () => {
      router.push(`/rooms/edit/${roomId}`);
    };
    
    return {
      roomDetail,
      getTypeName,
      getStatusName,
      getBedTypeName,
      handleBack,
      handleEdit
    };
  }
};
</script>

<style scoped>
.room-detail-container {
  padding: 20px;
}

.room-detail-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.detail-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.detail-actions .el-button {
  margin-right: 10px;
}
</style>